import { ReactNode } from 'react'
import { XIcon } from '@phosphor-icons/react'
import { createPortal } from 'react-dom'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  icon?: ReactNode
  children: ReactNode
  width?: string
  maxWidth?: string
  className?: string
  headerClassName?: string
  contentClassName?: string
  overlayClassName?: string
  usePortal?: boolean
  closeOnOverlayClick?: boolean
  disabled?: boolean
  hideCloseButton?: boolean
}

export function Modal({
  isOpen,
  onClose,
  title,
  icon,
  children,
  width = 'w-[500px]',
  maxWidth = 'max-w-[90vw]',
  className = '',
  headerClassName = '',
  contentClassName = '',
  overlayClassName = '',
  usePortal = false,
  closeOnOverlayClick = true,
  disabled = false,
  hideCloseButton = false,
}: ModalProps) {
  if (!isOpen) return null

  const handleOverlayClick = () => {
    if (closeOnOverlayClick && !disabled) {
      onClose()
    }
  }

  const modalContent = (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black/50 ${overlayClassName}`}
      onClick={handleOverlayClick}
    >
      <div
        className={`bg-gradient-to-b from-neutral-800 to-black border border-[#444] rounded-lg shadow-xl ${width} ${maxWidth} ${className}`}
        onClick={e => e.stopPropagation()}
      >
        {(title || icon) && (
          <div className={`flex items-center ${hideCloseButton ? 'justify-start' : 'justify-between'} p-4 border-b border-[#444] ${headerClassName}`}>
            <div className="flex items-center gap-2">
              {icon}
              {title && <h2 className="text-lg font-semibold text-white">{title}</h2>}
            </div>
            {!hideCloseButton && (
              <button
                onClick={onClose}
                className="text-[#888] hover:text-white transition-colors"
                disabled={disabled}
              >
                <XIcon size={24} />
              </button>
            )}
          </div>
        )}
        <div className={`p-4 space-y-4 ${contentClassName}`}>
          {children}
        </div>
      </div>
    </div>
  )

  if (usePortal) {
    return createPortal(modalContent, document.body)
  }

  return modalContent
}

